import React from 'react';
import {useIntl} from 'react-intl';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import ClearIcon from '@material-ui/icons/Clear';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import './BaseDialog.scss';

export type BaseDialogProps = {
  title?: string;
  open?: boolean;
  children?: React.ReactNode;
  renderActionButtons?: React.ReactNode;
  disableSubmit?: boolean;
  cancelLabel?: string;
  submitLabel?: string;
  className?: string;
  onClose?: () => void;
  onSubmit?: () => void;
};

export function BaseDialog({
  title,
  open = false,
  disableSubmit,
  cancelLabel,
  submitLabel,
  className,
  onClose,
  onSubmit,
  children,
  renderActionButtons,
}: BaseDialogProps) {
  const intl = useIntl();

  return (
    <Dialog
      className={`base-dialog ${className}`}
      open={open}
      onClose={onClose}
      aria-labelledby="base-dialog"
      aria-describedby="base-dialog-description"
      data-testid="base-dialog"
      id="base-dialog"
      maxWidth="lg"
    >
      {!!title && (
        <DialogTitle className="base-dialog__header" disableTypography={true}>
          <h2 className="base-dialog__header__title">{title}</h2>

          <ClearIcon
            className="base-dialog__header__close"
            onClick={() => {
              if (onClose) {
                onClose();
              }
            }}
          />
        </DialogTitle>
      )}
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        {renderActionButtons || (
          <>
            {' '}
            <Button onClick={onClose} variant="outlined">
              {cancelLabel ||
                intl.formatMessage({
                  id: 'form.cancel',
                })}
            </Button>
            <Button
              data-testid="base-dialog-ok"
              id="base-dialog-ok"
              onClick={onSubmit}
              variant="contained"
              color="primary"
              disableElevation
              disabled={disableSubmit}
            >
              {submitLabel ||
                intl.formatMessage({
                  id: 'form.submit',
                })}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}
